import * as api from "./../../api/index";
import * as ActionTypes from "./../ActionTypes";

export const fetchPosts = () => async (dispatch) => {
    try {
        const { data } = await api.fetchPosts();

        dispatch({
            type: ActionTypes.FETCH_POSTS,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}

export const newPost = (post) => async (dispatch) => {
    try {
        const { data } = await api.newPost(post);

        dispatch({
            type: ActionTypes.NEW_POST,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}

export const deletePost = (id) => async (dispatch) => {
    try {
        const { data } = await api.deletePost(id);

        dispatch({
            type: ActionTypes.DELETE_POST,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}

export const likePost = (id) => async (dispatch) => {
    try {
        const { data } = await api.likePost(id);

        dispatch({
            type: ActionTypes.LIKE_POST,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}

export const updatePost = (id, post) => async (dispatch) => {
    try {
        const { data } = await api.updatePost(id, post);

        dispatch({
            type: ActionTypes.UPDATE_POST,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}

export const newComment = (id, comment) => async (dispatch) => {
    try {
        const { data } = await api.newComment(id, comment);

        dispatch({
            type: ActionTypes.NEW_COMMENT,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}

export const delComment = (id, commentId) => async (dispatch) => {
    try {
        const { data } = await api.delComment(id, { commentId: commentId });

        dispatch({
            type: ActionTypes.DEL_COMMENT,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}